import React from 'react';
import { CalendarClockIcon } from 'lucide-react';
import { LAUNCH_DEADLINE } from '../data/programa';
export function LaunchOfferBadge({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-2 rounded-full border border-gold/60 bg-line px-4 py-1.5 text-[12px] font-medium uppercase tracking-[0.1em] text-gold shadow-[0_0_16px_rgba(255,159,28,0.28)] ${className}`} data-id="element-17" data-mp="13wkbh4n72e5x">
      <CalendarClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-18" data-mp="1wlzou12c0j50" />
      Oferta de lanzamiento
    </span>;
}
export function LaunchOfferBlock() {
  return <div className="mx-auto max-w-xl rounded-2xl border border-gold bg-white/[0.04] px-7 py-6 text-center backdrop-blur-[10px]" data-id="element-19" data-mp="1mveq8dmnrem3">
      <LaunchOfferBadge data-id="element-20" data-mp="1rson2ecdmsjy" />
      <p className="mt-4 text-[17px] font-semibold leading-snug text-ice" data-id="element-21" data-mp="1rrvdl5m19oy4">
        Precio de lanzamiento válido hasta el {LAUNCH_DEADLINE}
      </p>
      <p className="mt-2 text-[14px] leading-[1.6] text-cool" data-id="element-22" data-mp="2kaius9xwsjtx">
        Después sube $10.000 ARS y no vuelve al valor actual.
      </p>
    </div>;
}